import React, { ReactElement } from 'react'
import Link from 'next/link'
import { useRouter } from 'next/router'
import styled from '@emotion/styled'
import { motion } from 'motion/react'
import { Box, Image, Text, theme } from '@mindfulchefuk/design-system'

type TSearchResult = {
  title: string
  slug: string
  primaryImage: string
}

const variants = {
  hover: {
    scale: 1.02,
    transition: { ease: 'easeInOut' },
  },
}

const AnimatedBox = styled(motion.div)`
  border: ${theme.space[1]} solid ${theme.colors['pepper-200']};
  height: 100%;
`

export const SearchResult = ({
  title,
  slug,
  primaryImage,
}: TSearchResult): ReactElement => {
  const { query } = useRouter()

  const image = primaryImage
  const src = `${process.env.NEXT_PUBLIC_IMGIX_URL}${image}`
  const href = { pathname: '/healthy-recipes/[recipeSlug]', query }

  return (
    <AnimatedBox whileHover="hover" variants={variants}>
      <Link href={href} as={`/healthy-recipes/${slug}`} passHref>
        <Box as="a" overflow="hidden">
          <Image src={src} alt="" width={360} height={250} loading="eager" />
          <Text variant="heading-xs" color="aubergine" px={16} py={12}>
            {title}
          </Text>
        </Box>
      </Link>
    </AnimatedBox>
  )
}
